import { createContext } from 'react';
import type { Polygon } from 'geojson';
import type { MapView } from '../map/model';

export interface ImportMapInteraction {
  readonly drawing: boolean;
  readonly rectangle: Polygon | null;
  readonly view: MapView | null;
  readonly onRectangle: (rectangle: Polygon | null) => void;
  readonly onViewChange: (view: MapView) => void;
  readonly onEscape: () => void;
}

export const ImportMapContext = createContext<{
  readonly interaction: ImportMapInteraction | null;
  readonly setInteraction: (value: ImportMapInteraction | null) => void;
}>({ interaction: null, setInteraction: () => undefined });
